/*
* @TagTable.vue
* @Description 历史轨迹组件
* @Author
* @Date 2021/8/17
*/
<template>
    <div class="table-item-box padding-l-none" style="padding: 0;">
        <section style="height: 100%;padding: 10px;">

			    <div :class="{'el-table-box over-hide': true, 'no-pagination': true}">
				      <!-- 表格
	            v-loading="tableLoading"
	                      v-el-table-infinite-scroll="loadTableData"
	                      :infinite-scroll-disabled="tableDisabled"-->
	           <el-table :data="trackInfos"
	                      ref="multipleTable"
	                      style="height: 100%;"
	                      :class="{'table': true, 'no-pagination': true}"
	                      :empty-text="tableLoadingInfo"
	                      v-loading="tableLoading"
	                      v-el-table-infinite-scroll="loadTableData"
	                      :infinite-scroll-disabled="tableDisabled"
	           >
	               <el-table-column label="序号" min-width="60px">
	                   <template slot-scope="scope">
	                       <span style="white-space: nowrap;">{{scope.$index+1}}</span>
	                   </template>
	               </el-table-column>
	                <el-table-column label="组名" v-if="filters.bindingType==1" min-width="100px">
	                    <span style="white-space: nowrap;" :title="trackObj.groupName">{{trackObj.groupName}}</span>
	                </el-table-column>
	                <el-table-column label="编号" v-if="filters.bindingType==1" min-width="150px">
	                    <span style="white-space: nowrap;" :title="trackObj.idCard">{{trackObj.idCard}}</span>
	                </el-table-column>
	                <el-table-column label="姓名" v-if="filters.bindingType==1" min-width="100px">
	                    <span style="white-space: nowrap;" :title="trackObj.userName">{{trackObj.userName}}</span>
	                </el-table-column>
	                <el-table-column label="车类型" v-if="filters.bindingType==2" min-width="100px">
	                    <span style="white-space: nowrap;" :title="trackObj.carType">{{trackObj.carType}}</span>
	                </el-table-column>
	                <el-table-column label="车牌号" v-if="filters.bindingType==2" min-width="100px">
	                    <span style="white-space: nowrap;" :title="trackObj.carNumber">{{trackObj.carNumber}}</span>
	                </el-table-column>
	                <el-table-column label="工具编号" v-if="filters.bindingType==3" min-width="100px">
	                    <span style="white-space: nowrap;" :title="trackObj.toolNum">{{trackObj.toolNum}}</span>
	                </el-table-column>
	                <el-table-column label="工具名称" v-if="filters.bindingType==3" min-width="100px">
	                    <span style="white-space: nowrap;" :title="trackObj.toolName">{{trackObj.toolName}}</span>
	                </el-table-column>
	                <el-table-column label="状态" min-width="60px">
	                    <template slot-scope="scope">
	                        <span style="white-space: nowrap;" v-if="scope.row.state==0">正常</span>
	                        <span style="white-space: nowrap;" v-else>报警</span>
	                    </template>
	                </el-table-column>
	                <el-table-column label="位置" min-width="120px">
	                    <template slot-scope="scope">
	                        <span style="white-space: nowrap;" :title="($checkEmpty(scope.row.areaName) ? '' : ('区域：' + scope.row.areaName + '\n')) + ($checkEmpty(scope.row.mapName) ? '' : ('地图:' + scope.row.mapName))">{{( $checkEmpty(scope.row.areaName) ? '' : (scope.row.areaName + '-')) + ($checkEmpty(scope.row.mapName) ? '' : scope.row.mapName)}}</span>
	                    </template>
	                </el-table-column>
	                <el-table-column label="坐标" min-width="120px">
	                    <template slot-scope="scope">
	                        <span style="white-space: nowrap;" :title="'x：' + scope.row.rX + '\ny:' + scope.row.rY">{{'[' + scope.row.rX + ', ' + scope.row.rY + ']'}}</span>
	                    </template>
	                </el-table-column>
	                <el-table-column label="上报时间" min-width="150px">
	                    <template slot-scope="scope">
	                        <span style="white-space: nowrap;">{{scope.row.time}}</span>
	                    </template>
	                </el-table-column>
	            </el-table>

	            <!-- ======================= 导出所需数据 =============================== -->
	            <el-table :data="exportTrackInfos"  id="out-table" stripe  style="display: none;" class="table">
	                <el-table-column label="序号" min-width="60px">
	                    <template slot-scope="scope">
	                        <span style="white-space: nowrap;">{{scope.$index + 1}}</span>
	                    </template>
	                </el-table-column>
	                <el-table-column label="编号" v-if="filters.bindingType==1" min-width="150px">
	                    <span style="white-space: nowrap;" :title="trackObj.idCard">{{trackObj.idCard}}</span>
	                </el-table-column>
	                <el-table-column label="姓名" v-if="filters.bindingType==1" min-width="100px">
	                    <span style="white-space: nowrap;" :title="trackObj.userName">{{trackObj.userName}}</span>
	                </el-table-column>
	                <el-table-column label="车类型" v-if="filters.bindingType==2" min-width="100px">
	                    <span style="white-space: nowrap;" :title="trackObj.carType">{{trackObj.carType}}</span>
	                </el-table-column>
	                <el-table-column label="车牌号" v-if="filters.bindingType==2" min-width="100px">
	                    <span style="white-space: nowrap;" :title="trackObj.carNumber">{{trackObj.carNumber}}</span>
	                </el-table-column>
	                <el-table-column label="工具编号" v-if="filters.bindingType==3" min-width="100px">
	                    <span style="white-space: nowrap;" :title="trackObj.toolNum">{{trackObj.toolNum}}</span>
	                </el-table-column>
	                <el-table-column label="工具名称" v-if="filters.bindingType==3" min-width="100px">
	                    <span style="white-space: nowrap;" :title="trackObj.toolName">{{trackObj.toolName}}</span>
	                </el-table-column>
	                <el-table-column label="状态" min-width="60px">
	                    <template slot-scope="scope">
	                        <span style="white-space: nowrap;" v-if="scope.row.state==0">正常</span>
	                        <span style="white-space: nowrap;" v-else>报警</span>
	                    </template>
	                </el-table-column>
	                <el-table-column label="区域" min-width="120px">
	                    <template slot-scope="scope">
	                        <span style="white-space: nowrap;">{{scope.row.areaName}}</span>
	                    </template>
	                </el-table-column>
	                <el-table-column label="位置" min-width="120px">
	                    <template slot-scope="scope">
	                        <span style="white-space: nowrap;">{{scope.row.mapName}}</span>
	                    </template>
	                </el-table-column>
	                <el-table-column label="X坐标" min-width="120px">
	                    <template slot-scope="scope">
	                        <span style="white-space: nowrap;">{{scope.row.rX}}</span>
	                    </template>
	                </el-table-column>
	                <el-table-column label="Y坐标" min-width="120px">
	                    <template slot-scope="scope">
	                        <span style="white-space: nowrap;">{{scope.row.rY}}</span>
	                    </template>
	                </el-table-column>
	                <el-table-column label="上报时间" min-width="150px">
	                    <template slot-scope="scope">
	                        <span style="white-space: nowrap;">{{scope.row.time}}</span>
	                    </template>
	                </el-table-column>
	            </el-table>
			    </div>

          <!--查询工具条-->
          <el-col style="padding-top: 10px;overflow: auto;">
            <el-form :inline="true" :model="filters" ref="filters" :rules="rules" >
              <el-form-item prop="keyword" class="select-input-complete">
                <el-form-item>查询条件：</el-form-item>
                <el-select v-model="filters.bindingType" @change="changeBdType" style="width: 100px;">
                  <el-option v-for="(item, index) in filters.bindingTypes" :key="index" :label="item.label" :value="item.type"></el-option>
                </el-select>
                <el-autocomplete
                    :style="{width:'300px'}"
                    ref="elautocomplete"
                    class="inline-input"
                    v-model="filters.keyword"
                    :fetch-suggestions="querySearch"
                    :placeholder="filters.placeholderOpt[filters.bindingType]"
                    :trigger-on-focus="false"
                    clearable
                    @select="handleSelect"
                    @keyup="changeStyle('block', '.el-autocomplete-suggestion')"
                >
                </el-autocomplete>
              </el-form-item>
              <el-form-item prop="duration" class="item-cnt-lhfs-0">
                <el-date-picker
                    :picker-options="filters.pickerOptions"
                    v-model="filters.duration"
                    type="datetimerange"
                    range-separator="—"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    @change="changeTime"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="timeDiff">
                <el-select v-model="filters.timeDiff" placeholder="定位间隔" @change="changeTimeDiff" :style="{width: '200px'}">
                  <el-option v-for="item in filters.timeDiffs" v-if="item.showFlag" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="searchTrack" trigger="click">查询</el-button>
              </el-form-item>
              <el-form-item v-if="computeTrack.length > 0" style="float: right;">共查询到 <b>{{computeTrack.length}}</b> 条数据</el-form-item>
              <el-form-item style="position: absolute;top: 9px;right: 20px;margin: 0px;z-index: 3;">
                <el-button icon="el-icon-video-play" type="primary" size="mini" trigger="click" @click="trackPlay" style="padding: 7px 10px;">轨迹播放</el-button>
                <el-button icon="el-icon-s-data" type="primary" size="mini" trigger="click" @click="trackAnalysis" style="padding: 7px 10px;">轨迹分析</el-button>
                <el-button icon="el-icon-download" type="primary" size="mini" trigger="click" @click="searchExportData" style="padding: 7px 10px;">数据导出</el-button>
              </el-form-item>
            </el-form>
          </el-col>

			    <!-- 组件 轨迹分析 -->
          <LocationTrackAnalysis ref="locationTrackAnalysis" />
          <!-- 组件 轨迹播放 -->
          <LocationTrackPlay ref="locationTrackPlay"/>

        </section>
    </div>

</template>

<script>
    // 公用函数
    import GlobalFun from '@/global/global-function'
    // API 人员信息
    import ApiUser from '@/request/api-user'
    // API 车辆信息
    import ApiCar from '@/request/api-car'
    // API 资源信息
    import ApiOam from '@/request/api-oam'
    // 加载
    import {Loading} from 'element-ui'
    import LocationTrackAnalysis from "./LocationTrackAnalysis";
    import LocationTrackPlay from "./LocationTrackPlay";

    export default {
        /**
         * @Des 组件名称
         * @Auth
         * @Date 2021/8/17
         */
        name: "LocationTrackTable",
        /**
         * @Des 组件引用注册
         * @Auth
         * @Date 2021/8/17
         */
        components: {
            LocationTrackPlay,
            LocationTrackAnalysis
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/8/17
         */
        data() {
            return {
                /**
                 * @Des 查询条件属性
                 * @Auth
                 * @Date 2021/8/17
                 */
                filters: {
                    timeDiffs: [{
                        value: 100,
                        label: '定位间隔：100毫秒',
                        showFlag: true,
                    },{
                        value: 1000,
                        label: '定位间隔：1秒',
                        showFlag: true,
                    },{
                        value: 10000,
                        label: '定位间隔：10秒',
                        showFlag: true,
                    },{
                        value: 60000,
                        label: '定位间隔：1分钟',
                        showFlag: false,
                    },{
                        value: 600000,
                        label: '定位间隔：10分钟',
                        showFlag: false,
                    }],
                	// 时间间隔 ms
                	timeDiff: 10000,
                    // 是否插值
                    interpolation: true,
                    // 查询的时间间隔
                    searchIntervalHours: 4,
                    // 关键词
                	keyword: '',
                    // 开始时间 - 结束时间
                    duration: '',
                    // 绑定类型
                    bindingType: '',
                    // 绑定类型
                    bindingTypes: [],
                    // placeholder
                    placeholderOpt: {1: '请输入人员姓名/编号',2: '请输入车辆类型/车牌号'},
                    // 查询
                    queryString: '',
                    // 查询的绑定id
                    bindingId: '',
                    // 隐藏的时间
                    pickerOptions:{
                	    disabledDate(v){
                	        return v.getTime() > new Date().getTime()
                        }
                    },
                },
                // 查询对象
                trackObj: {},
                // 人员
                users: [],
                // 车辆
                cars: [],
                // 工具
                tools: [],
                // 查询
                tableLoadingInfo: '暂无数据',
                // 轨迹集合
                trackInfos:[],
                // 计算轨迹
                computeTrack: [],
                // 导出轨迹集合
                exportTrackInfos: [],
                // 锁
                locked: false,
                // 区域信息
                areas: {},
                // 地图信息
                maps: {},
                // 加载中
                loading: '',

                // 表格滚动加载，未实现
                tableLoading: false,
                tableDisabled: false,
                tableShowNum: 100,

                /**
                 * @Des 规则属性
                 * @Auth
                 * @Date  2021/7/29
                 */
                rules: {
                    keyword: [
                        { required: true, message: '请输入关键词进行匹配', trigger: 'blur' },
                    ],
                    duration: [{
                        validator: (rule, value, callback) => {
                            // 校验时间
                            if (this.$checkEmpty(value)) {
                                new callback(new Error('请选择开始时间与结束时间'));
                            } else if (this.$checkEmpty(value[0])) {
                                new callback(new Error('请选择开始时间'));
                            } else if (this.$checkEmpty(value[1])) {
                                new callback(new Error('请选择结束时间'));
                            } else if (value[0] >= value[1]) {
                                new callback(new Error('结束时间须晚于开始时间'));
                            }  else {
                                callback()
                            }
                        },
                    }],
                },
                // 计时器
                timer_searchData: null,
            }
        },
        computed: {
        },
		/**
		 * @Des 初始化加载处理
		 * @Auth
		 * @Date 2021/8/17
		 */
		created(){
		    this.getBindingTypes();
		    this.findOrg();
		},
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 2021/8/17
		 */
		mounted(){
		},
		/**
         * @Des 销毁
         * @Auth
         * @Date 
         */
        beforeDestroy() {
			// 关闭 timer
        	this.endTimers();
        },
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 2021/8/17
		 */
		methods: {
			/**
        	 * @Des 关闭 timer
        	 * @Auth
        	 * @Date
        	 */
        	endTimers() {
        		// 清除计时器
                if (this.timer_searchData != null) {
                	clearTimeout(this.timer_searchData);
                	this.timer_searchData = null;
                }
        	},
            /**
             * @Des 获取绑定类型
             * @Auth
             * @Date 2021/6/19
             */
            getBindingTypes(){
                // let routerPath = GlobalFun.getRouterPath(this.$router.options.routes);
                this.$request.postJsonRequest(ApiOam.Search_All_Resources_Uri, {
                    resourceType: 1,
                    showType: this.$store.state.showType,// 20,
                }).then(result => {
                    // console.log(result);
                    if(result.total > 0){
                        result.rows.forEach((row, index) => {
                            if(row.resourceUri == this.$store.state.infoUri[0]){
                                this.filters.bindingTypes.push({
                                    label: '人员',
                                    type: 1,
                                })
                                // 绑定类型
                    			this.filters.bindingType = 1;
                            }else if(row.resourceUri == this.$store.state.infoUri[1]){
                                this.filters.bindingTypes.push({
                                    label: '车辆',
                                    type: 2,
                                })
                                // 绑定类型
                    			this.filters.bindingType = 2;
                            }
                        })
                    }
                }).catch(error => {
                    console.error('获取绑定类型异常', ApiOam.Search_All_Resources_Uri, error);
                })
            },

            /**
             * @Des 时间改变
             * @Auth
             * @Date 2021/6/19
             */
            changeTime(value){
                // console.log(value)
                // 空值 中止
                if (this.$checkEmpty(value)) return false;

                let timer = new Date(value[1]).getTime() - new Date(value[0]).getTime();
                
                if(timer <= 2 * 60 * 60 * 1000){
                    // 2小时的数据
                    this.filters.timeDiff = 1000;
                }else {
                    // 4小时的数据
                    this.filters.timeDiff = 10000;
                }
                
                return false;
                if(timer <= 2 * 60 * 60 * 1000){
                    // 2小时的数据
                    this.filters.timeDiff = 1000;
                }else if(timer <= 4 * 60 * 60 * 1000){
                    // 4小时的数据
                    this.filters.timeDiff = 10000;
                }else if(timer <=  8 * 60 * 60 * 1000){
                    // 8小时的数据
                    this.filters.timeDiff = 60000;
                }else {
                    // 8小时以上的数据
                    this.filters.timeDiff = 600000;
                }
            },

            /**
             * @Des 时间差改变
             * @Auth
             * @Date 2021/6/19
             */
            changeTimeDiff(){
                // console.log(this.filters.timeDiff)
                /*let beginTime = new Date(this.filters.duration[0]).getTime();
                let endTime = new Date(this.filters.duration[1]).getTime();
                let count = (endTime - beginTime)/this.filters.timeDiff;
                if(count > 10000){
                    this.$message({
                        message: '友情提示：需要处理的数据量较大，请缩短查询时间段，或放大时间间隔',
                        type: 'info',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                }*/
            },

            /**
             * @Des 加载
             * @Auth
             * @Date 2021/6/19
             */
            startLoading(text = '加载中...') {
                this.loading = Loading.service({
                    lock: true,
                    text: text,
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },

            /**
             * @Des 关闭加载窗
             * @Auth
             * @Date 2021/6/19
             */
            closeLoading(){
                this.loading.close();
            },

            /**
             * @Des 绑定类型改变
             * @Auth
             * @Date 2021/8/17
             */
            changeBdType() {
			        // 重置绑定id
            	this.filters.bindingId = '';
            	// 重置 keyword
            	this.filters.keyword = '';
            },

            /**
             * @Des 改变样式
             * @Auth
             * @Date 2021/8/17
             */
            changeStyle(status, className){
                let dom = document.querySelectorAll(className);
                dom[0].style.display = status;
            },

            /**
             * @Des 匹配建议
             * @Auth
             * @Date 2021/8/17
             */
            querySearch(queryString, callback) {
                if(queryString == ''){
                    this.changeStyle('none', '.el-autocomplete-suggestion');
                    return;
                }
                switch(this.filters.bindingType) {
                    case 1:
                        this.searchUser(callback);
                        break;
                    case 2:
                        this.searchCar(callback);
                        break;
                    case 3:
                        //this.searchTool(callback);
                        break;
                    default :
                        break;
                }
              },
              /**
               * @Des 选择建议
               * @Auth
               * @Date 2021/8/17
               */
              handleSelect(item) {
                if(item.id == '0'){
                    this.filters.bindingId = '';
                    this.filters.keyword = '';
                    return false;
                }
                this.filters.bindingId = item.id;
                this.trackObj = item;
			        },

              findOrg(){
                this.$request.postJsonRequest(ApiOam.Find_Org_Uri,{
                  projectId: this.$store.state.currentProjectId,
                }).then(result => {
                  // console.log(result)
                  this.areas = Object.assign({}, {});
                  this.maps = Object.assign({}, {});
                  if(result.code == 0 && result.data && result.data.length > 0){
                    result.data.forEach((row, index) => {
                      if(row.level == 2){
                        this.areas[row.id] = row.node;
                      }
                      if(row.level == 3){
                        this.maps[row.id] = row.node;
                      }
                    })
                  }
                }).catch(error => {
                	console.error('查询组织结构异常', ApiOam.Find_Org_Uri, error);
                })
              },

            /**
             * @Des 查询人员
             * @Auth
             * @Date 2021/8/17
             */
            searchUser(callback){
                this.$request.postJsonRequest(ApiUser.searchUserApi,{
                    keyword: this.filters.keyword,
                    projectId: this.$store.state.currentProjectId,
                    orderBy: {
                        user_name: 'asc'
                    }
                }).then(result => {
                    // console.log(result)
                    // 人员 list
                    this.users = result.rows;
                    result.rows.forEach((row, index) => {
                        row.value = row.idCard + "：" + row.userName;
                        row.id = row.userId;
                    })
                    if(this.users.length > 0){
                        callback && callback(this.users);
                    }else{
                        callback && callback([{value: '未匹配到人员', id: '0'}]);
                    }
                }).catch(error => {
                    console.error('查询人员异常', ApiUser.searchUserApi, error);
                })
            },
            /**
             * @Des 查询车辆
             * @Auth
             * @Date 2021/8/17
             */
            searchCar(callback){
                this.$request.postJsonRequest(ApiCar.searchCarApi,{
                    keyword: this.filters.keyword,
                    projectId: this.$store.state.currentProjectId,
                    orderBy: {
                        car_number: 'asc'
                    }
                }).then(result => {
                    // console.log(result)
                    // 车辆 list
                    this.cars = result.rows;
                    result.rows.forEach((row, index) => {
                        row.value = row.carType + "：" + row.carNumber;
                        row.id = row.carId;
                    })
                    if(this.cars.length > 0){
                        callback && callback(this.cars);
                    }else{
                        callback && callback([{value: '未匹配到车辆', id: '0'}]);
                    }
                }).catch(error => {
                    console.error('查询车辆异常', ApiCar.searchCarApi, error);
                })
            },

            /**
             * @Des 查询轨迹
             * @Auth
             * @Date 2021/8/17
             */
            searchTrack() {
                // 交互锁
                if (this.locked) {
                  return false;
                }

                this.$refs.filters.validate(valid => {
                    if (!valid) return false;
                    if(this.filters.bindingId == ''){
                        this.$message({
                            message: '请输入要查询的对象',
                            type: 'warning',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        return false;
                    }
                    let beginTime = new Date(this.filters.duration[0]).getTime();
                    let endTime = new Date(this.filters.duration[1]).getTime();
                    this.tableLoading = false;
                    this.tableDisabled = false;
                    this.locked = true;
                    this.trackInfos = [];
                    this.computeTrack = [];
                    this.exportTrackInfos = [];
                    this.searchData(beginTime, endTime);
                });
            },

            /**
             * @Des 查询数据
             * @Auth
             * @Date 2021/9/15
             */
            searchData(beginTime, endTime){
                // 清除计时器
                if (this.timer_searchData != null) {
                	clearTimeout(this.timer_searchData);
                	this.timer_searchData = null;
                }
                
                if(beginTime >= endTime){
                    console.log(this.computeTrack.length+'条数据正在处理中，请稍后....')
                    this.startLoading(this.computeTrack.length+'条数据正在处理中，请稍后....');
                    setTimeout(() => {
                        if(this.computeTrack.length > this.tableShowNum){
                          let trackData = Object.assign([], this.computeTrack);
                          this.trackInfos = trackData.splice(0, this.tableShowNum);
                          trackData = [];
                        }else{
                          this.trackInfos = this.computeTrack;
                        }
                        this.$nextTick(() => {
                            // this.computeTrack = [];
                            this.locked = false;
                            this.closeLoading();
                        })
                    },500)
                    return;
                }
                let searchEndTime = endTime;
                if(searchEndTime - beginTime > this.filters.searchIntervalHours * 60 * 60 * 1000){
                    searchEndTime = beginTime + this.filters.searchIntervalHours * 60 * 60 * 1000;
                }
                let searchB = this.$moment(new Date(beginTime)).format('YYYY-MM-DD HH:mm:ss');
                let searchE = this.$moment(new Date(searchEndTime)).format('YYYY-MM-DD HH:mm:ss');
                this.startLoading('正在查询' + searchB + ' 至 ' + searchE + '的数据....');
                // 查询轨迹
                this.$request.postJsonRequest(ApiOam.Search_Track_Uri, {
                    projectId: this.$store.state.currentProjectId,
                    beginTime: beginTime,
                    endTime: searchEndTime,
                    timeD: this.filters.timeDiff,
                    searchType: this.filters.bindingType,
                    bindingId: this.filters.bindingId,
                    interpolation: this.filters.interpolation
                }).then(result => {
                    // console.log(result)
                    if (result.code == 0) {
                        if(result.data.positionList.length > 0){
                            // 查询成功
                            if(this.filters.interpolation){
                                let format = 'YYYY-MM-DD HH:mm:ss';
                                if(this.filters.timeDiff < 1000){
                                    format = 'YYYY-MM-DD HH:mm:ss.SSS';
                                }
                                // 查询有数据, 补充上一个数据
                                let et = result.data.positionList[0].t;
                                if(this.computeTrack.length > 0){
                                    // 已经存在，补充数据
                                    let bt = this.computeTrack[this.computeTrack.length-1].t + this.filters.timeDiff;
                                    let computeTrack = this.computeTrack[this.computeTrack.length-1];
                                    while (bt < et){
                                        computeTrack.t = bt;
                                        computeTrack.time = this.$moment(new Date(bt)).format(format);
                                        this.computeTrack.push(Object.assign({}, computeTrack));
                                        bt += this.filters.timeDiff;
                                    }
                                }
                                result.data.positionList.forEach((row, index) => {
                                    row.areaName = '';
                                    row.mapName = '';
                                    if(this.maps.hasOwnProperty(row.mapId)){
                                      row.mapName = this.maps[row.mapId].mapName;
                                      row.areaId = this.maps[row.mapId].areaId;
                                      if(row.areaId && this.areas.hasOwnProperty(row.areaId)){
                                        row.areaName = this.areas[row.areaId].areaName;
                                      }
                                    }
                                    row.time = row.t?this.$moment(new Date(row.t)).format(format):'';
                                    // row.x = 0;
                                    // row.y = 0;
                                    this.computeTrack.push(row);
                                })
                            }
                        }
                    }
                    this.timer_searchData = setTimeout(()=>{
                        this.closeLoading();
                        this.searchData(searchEndTime, endTime);
                    }, 500)
                }).catch(error => {
                    this.timer_searchData = setTimeout(()=>{
                        this.closeLoading();
                        this.searchData(searchEndTime, endTime);
                    }, 500)
                    
                    console.error('查询轨迹异常', ApiOam.Search_Track_Uri, error);
                })
            },

            /**
             * @Des 查询导出数据
             * @Auth
             * @Date 2021/8/17
             */
            searchExportData() {
                if(this.locked) return false;
                this.locked = true;
                this.startLoading('数据导出中，请稍后....');
                this.exportTrackInfos = [];
                if(this.trackInfos.length == 0){
                    this.$message({
                        message: '没有查询到数据，无法导出',
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    this.closeLoading();
                    this.locked = false;
                    return false;
                }
                setTimeout(()=>{
                    this.exportTrackInfos = this.computeTrack;
                    this.$nextTick(() => {
                        GlobalFun.exportExcel(document.querySelector("#out-table"),this.filters.keyword + '的轨迹信息.xlsx', () => {
                            // 关闭加载窗
                            this.closeLoading();
                            this.locked = false;
                        });
                    })
                }, 500)
            },

            /**
             * @Des 轨迹播放
             * @Auth
             * @Date 2021/8/17
             */
            trackPlay() {
                if(this.computeTrack.length == 0){
                    this.$message({
                        message: '没有查询到数据，无法播放',
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }
                this.$refs.locationTrackPlay.openDialog(this.filters.bindingType, this.trackObj, this.computeTrack, this.filters.timeDiff);
            },

            /**
             * @Des 轨迹分析
             * @Auth
             * @Date 2021/8/17
             */
            trackAnalysis() {
                if(this.computeTrack.length == 0){
                    this.$message({
                        message: '没有查询到数据，无法分析',
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }
                this.$refs.locationTrackAnalysis.openDialog(this.filters.bindingType, this.trackObj, this.computeTrack);
            },
            /**
             * @Author ZhangBin
             * @Description //TODO 每次滚动显示100条数据, 方法失效
             * @Date 22:27 2022/6/18
             * @Param
             * @return
             **/
			loadTableData(){
				if(this.trackInfos.length >= this.computeTrack.length) {
					this.trackInfos.length > 0 && this.$message('轨迹数据已加载完毕。');
					return;
				}
				this.tableLoading = true;
				this.tableDisabled = true;
				
				setTimeout(() => {
					if(this.trackInfos.length + this.tableShowNum > this.computeTrack.length){
						let trackData = Object.assign([], this.computeTrack);
						let nextData = trackData.splice(this.trackInfos.length-1, this.computeTrack.length - this.trackInfos.length);
						this.trackInfos = Object.assign([], this.trackInfos.concat(nextData));
					}else{
						let trackData = Object.assign([], this.computeTrack);
						let nextData = trackData.splice(this.trackInfos.length-1, this.tableShowNum);
						this.trackInfos = Object.assign([], this.trackInfos.concat(nextData));
					}
				}, 400);
				
				setTimeout(() => {
					this.tableDisabled = false;
					this.tableLoading = false;
				}, 800);
			}
		},
		
    }
</script>

<style scoped>
    *{
        box-sizing: border-box;
    }
    
	.el-table-box {
		width: 100%;
		height: calc(100% - 110px);
    }
	.el-table-box.no-pagination {
	    height: calc(100% - 60px);
	}
	
    .el-table {
        height: calc(100% - 110px);
        overflow-x: auto;
    }
    .el-table.no-pagination {
        height: calc(100% - 60px);
    }
    /deep/ .el-table__body-wrapper {
        height: calc(100% - 50px);
        overflow-y: auto;
    }
    /deep/ .el-loading-mask {
    	background-color: rgba(0,0,0,.5);
    }
    
    /deep/ .el-col .el-form-item__error {
		display: none !important;
	}

</style>



// WEBPACK FOOTER //
// src/components_pages/Location/LocationTrackTable.vue